import { getFormattedLinkToBrowser } from '~/utils/url';

export const GENERAL_CONDITIONS_LINK = getFormattedLinkToBrowser(
  'https://psffiles.blob.core.windows.net/psfcontratos/termos/seguros/sulamerica/plano-odonto/condicoes-gerais-contratacao.pdf'
);
